import { createMemoryHistory, createRouter } from 'vue-router'
import LoginComponent from '../components/LoginComponent.vue'
import DashboardComponent from '../components/DashboardComponent.vue'
import PartnersCustomersHeatmap from '@/views/PartnersCustomersHeatmap.vue'
import OrdersList from '@/views/OrdersList.vue'
import DiscountCodes from '@/views/DiscountCodes.vue'
import AccountDetails from '@/views/AccountDetails.vue'
import CustomerSupport from '@/views/CustomerSupport.vue'
import PaymentMethods from '@/views/PaymentMethods.vue'
import OrderDetails from '@/views/OrderDetails.vue'
import PasswordReset from '@/views/PasswordReset.vue'
//import Mixin from '../mixins/global.mixin'


const routes = [
  {
    path: '/',
    redirect: '/login', // Redirect home to login
  },
  { path: '/login', name: 'Login',
    component: LoginComponent,
    meta: { requiresGuest: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardComponent,
    meta: { requiresAuth: true },
    children: [
      {
        path: '', // Empty path for default route
        redirect: 'my-orders' // Redirect to the default child route
      },
      { path: 'partners-customers-heatmap',
        component: PartnersCustomersHeatmap,
        name: 'PartnersCustomersHeatmap' },
      {
        path: 'my-orders',
        component: OrdersList,
        name: 'OrdersList'
      },
      {
        path: 'my-orders/:orderId',  // Dynamic segment for order ID
        component: OrderDetails,
        name: 'OrderDetails'
      },
      { path: 'discount-codes', component: DiscountCodes, name: 'DiscountCodes'  },
      { path: 'my-account', component: AccountDetails, name: 'AccountDetails'  },
      { path: 'password-reset', component: PasswordReset, name: 'PasswordReset'  },
      { path: 'customer-support', component: CustomerSupport, name: 'CustomerSupport'  },
      { path: 'payment-methods', component: PaymentMethods, name: 'PaymentMethods'  },
    ]
  }
]

const router = createRouter({
  history: createMemoryHistory(process.env.BASE_URL),
  routes,
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  var token = null;
  if (localStorage.getItem('vuex')) {
     token = JSON.parse(localStorage.getItem('vuex'))?.jwtToken;
  }
  

  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // If no token, redirect to login
    if (!token) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    // Prevent authenticated users from accessing guest routes like Login
    if (token) {
      next({ name: 'OrdersList' }); // Adjust this to your default authenticated route
    } else {
      next();
    }
  } else {
    next(); // Always call next() to resolve the hook
  }
});


export default router